import type { IconData } from '@stacksjs/iconify-core'

export const messagesF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.656 17.979A1 1 0 0 1 2 17.243V15a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.003zM16 10.017a7 7 0 0 0 0 .369zq.007-.16.004-4.019a3 3 0 0 0-3-2.997H5V2a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2v2.243a1 1 0 0 1-1.656.736L16 13.743z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default messagesF
